export interface OperationProgressWindowSelectionCandidate {
  id: string;
  open: boolean;
  priority?: number;
  sequence: number;
}

export function selectOperationProgressWindowRequest<T extends OperationProgressWindowSelectionCandidate>(
  requests: Iterable<T>
): T | null {
  let selected: T | null = null;

  for (const request of requests) {
    if (!request.open) {
      continue;
    }

    if (
      !selected ||
      (request.priority ?? 0) > (selected.priority ?? 0) ||
      ((request.priority ?? 0) === (selected.priority ?? 0) && request.sequence > selected.sequence)
    ) {
      selected = request;
    }
  }

  return selected;
}
